module.exports = __webpack_public_path__ + "img/2.9119ef21.jpg";